import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  GuardResult,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthStatusType } from '../../../services/auth/auth-state.service';
import { MDB_AUTH_STATUS } from '../../../services/auth/tokens';

export const isUnauthenticated: CanActivateFn = (
  _next: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): GuardResult => {
  const authStatus = inject(MDB_AUTH_STATUS)();
  const router = inject(Router);

  if (authStatus === AuthStatusType.Authenticated) {
    return router.createUrlTree(['/app/home']);
  }

  return true;
};
